import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
import {
	ProductListViewCustomizationComponent
} from '../shared/components/view-customization/product-list-customization.component';

import { EOrderComponent } from './components/eorder.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { eOrderUserGuard } from './guards/eorder-user.guard';
import { eorderWizardExitGuard } from './guards/eorder-wizard-exit.guard';
import { eorderWizardEnterGuard } from './guards/eorder-wizard-enter.guard';
import { productFieldNamesTranslationGuard } from './guards/product-field-names-translation.guard';
import { PAGE_NAME_STEPS } from './services/eorder-wizard.service';
import { StepHeaderComponent } from './components/wizard/step-header/step-header.component';
import { OrderDraftListComponent } from './components/list/order-draft-list.component';
import { ViewCartComponent } from './components/wizard/view-cart/view-cart.component';
import { StepSummaryComponent } from './components/wizard/step-summary/step-summary.component';
import { OrderCardComponent } from './components/cards/order-card/order-card.component';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY },
	},
	{
		path: 'ordercreation',
		component: EOrderComponent,
		canActivate: [eOrderUserGuard],
		data: { pageName: 'eOrder - Creation', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
	},
	{
		path: 'draft',
		component: OrderDraftListComponent,
		canActivate: [eOrderUserGuard],
		data: { pageName: 'eOrder - Draft List', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
	},
	{
		path: 'wizard',
		component: WizardComponent,
		canDeactivate: [eorderWizardExitGuard],
		children: [
			{
				path: '',
				redirectTo: PAGE_NAME_STEPS[0],
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
			},
			{
				path: PAGE_NAME_STEPS[0],
				children: [
					{
						path: '',
						component: StepHeaderComponent,
						canActivate: [eorderWizardEnterGuard, eOrderUserGuard, productFieldNamesTranslationGuard],
						// eslint-disable-next-line @stylistic/max-len
						data: { pageName: 'eOrder - Wizard Step 1 (Product Selection)', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
					},
					{
						path: 'view',
						component: ProductListViewCustomizationComponent,
						canActivate: [eorderWizardEnterGuard, eOrderUserGuard, productFieldNamesTranslationGuard],
						data: { pageName: 'eOrder - Wizard Customization', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
					}
				]
			},
			{
				path: PAGE_NAME_STEPS[1],
				component: ViewCartComponent,
				canActivate: [eorderWizardEnterGuard, eOrderUserGuard, productFieldNamesTranslationGuard],
				data: { pageName: 'eOrder - Wizard Step 2 (Cart)', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
			},
			{
				path: PAGE_NAME_STEPS[2],
				component: StepSummaryComponent,
				canActivate: [eorderWizardEnterGuard, eOrderUserGuard, productFieldNamesTranslationGuard],
				data: { pageName: 'eOrder - Wizard Step 3 (Summary)', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
			}
		]
	},

	{
		path: 'orders/:orderId',
		component: OrderCardComponent,
		canActivate: [productFieldNamesTranslationGuard],
		data: { pageName: 'eOrder - Card', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
	}
];
